import { LegalLayout } from "../components/LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy" description="How VoiceRanker.ai, operated by Digital Media Strategies Ltd, collects, uses and protects your personal information." testId="privacy-policy-page">
      <p>This Privacy Policy explains how VoiceRanker.ai ("we", "us", "our"), a website operated by <strong>Digital Media Strategies Ltd</strong>, collects, uses and protects information when you visit voiceranker.ai.</p>

      <h2>1. Information We Collect</h2>
      <p>We do not require you to create an account or submit personal information to use this website. We may collect:</p>
      <ul>
        <li><strong>Usage data</strong> — pages visited, time on site, referring URLs, browser type and device information, collected via analytics tools.</li>
        <li><strong>Cookies and similar technologies</strong> — small files stored on your device to remember preferences and measure site performance.</li>
        <li><strong>Contact information</strong> — if you email us, we receive your email address and the contents of your message.</li>
      </ul>

      <h2>2. How We Use Information</h2>
      <ul>
        <li>To operate, maintain and improve the website and its content.</li>
        <li>To understand which articles and comparisons are most useful to readers.</li>
        <li>To respond to enquiries sent to us directly.</li>
        <li>To measure the performance of affiliate partnerships (see Section 4).</li>
      </ul>

      <h2>3. Cookies</h2>
      <p>We use cookies for analytics and affiliate tracking purposes. You can disable cookies in your browser settings at any time; the website will remain fully usable, though some measurement features may not function.</p>

      <h2>4. Affiliate Links and Third Parties</h2>
      <p>VoiceRanker.ai contains affiliate links. When you click an affiliate link, the destination network may set cookies or receive click identifiers so that purchases can be attributed to this website. We do not receive your payment details or personal information from these transactions — only aggregate commission reporting. Third-party websites linked from VoiceRanker.ai operate under their own privacy policies, which we encourage you to review.</p>

      <h2>5. Data Sharing</h2>
      <p>We do not sell, rent or trade your personal information. We may share limited data with service providers (such as analytics and hosting providers) who process it on our behalf, or where required by law.</p>

      <h2>6. Data Retention and Security</h2>
      <p>We retain analytics data only as long as necessary for the purposes described above and apply reasonable technical measures to protect any information we hold.</p>

      <h2>7. Your Rights</h2>
      <p>Depending on your jurisdiction, you may have rights to access, correct or delete personal data we hold about you, and to object to or restrict certain processing. To exercise these rights, contact us using the details below.</p>

      <h2>8. Children</h2>
      <p>This website is not directed at children under 16 and we do not knowingly collect information from them.</p>

      <h2>9. Changes to This Policy</h2>
      <p>We may update this Privacy Policy from time to time. The "Last updated" date at the top of this page reflects the most recent revision.</p>

      <h2>10. Contact</h2>
      <p>Digital Media Strategies Ltd — operator of VoiceRanker.ai.<br />Email: <a href="mailto:support@voiceranker.ai">support@voiceranker.ai</a></p>
    </LegalLayout>
  );
}
